export default "/assets/lesson_builder_with_elearning_section-c412b5e6e9d85f4dd0b4416e08f999cd94b146e4ccee64593a97f5b85627b05c.png";